var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgDelete = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.57617 0V0.75H2.32617V1.5H11.3262V0.75H9.07617V0H4.57617Z",
    fill: "#E71E1E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.32617 9.75V5.25H6.07617V9.75H5.32617Z",
    fill: "#E71E1E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.57617 5.25V9.75H8.32617V5.25H7.57617Z",
    fill: "#E71E1E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.07617 2.25V10.5C3.07617 11.3284 3.74774 12 4.57617 12H9.07617C9.9046 12 10.5762 11.3284 10.5762 10.5V2.25H3.07617ZM9.82617 3H3.82617V10.5C3.82617 10.9142 4.16196 11.25 4.57617 11.25H9.07617C9.49039 11.25 9.82617 10.9142 9.82617 10.5V3Z",
    fill: "#E71E1E"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDelete);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/delete.0390eac3aeb4839f6905d2286151b758.svg";